<router-outlet *ngIf="!isB2cEnabled; else elseBlock"></router-outlet>
<ng-template #elseBlock>
  <router-outlet *ngIf="!isIframe"></router-outlet>
</ng-template>
